/* Décommenter la ligne si dessous pour activer UNISON */
// var allBreakpoints = Unison.fetch.all();


/*
      ##    #######   ##     ##  ########   ########   ##    ##   
      ##   ##     ##  ##     ##  ##         ##     ##   ##  ##    
      ##   ##     ##  ##     ##  ##         ##     ##    ####     
      ##   ##     ##  ##     ##  ######     ########      ##      
##    ##   ##  ## ##  ##     ##  ##         ##   ##       ##      
##    ##   ##    ##   ##     ##  ##         ##    ##      ##      
 ######     ##### ##   #######   ########   ##     ##     ##      
*/

var nav = responsiveNav(".nav-main", { // Selector
	label: "", // String: Label for the navigation toggle
	customToggle: ".custom-toggle"
});

$(".nav-footer").each(function(){	
	responsiveNav($(this).attr('id'), { // Selector
		label: "", // String: Label for the navigation toggle
		customToggle: $(this).prev('p').find('.footer-nav__toggle').attr('id')
	});
});


function getWindowWidth() {
	return Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
}

function checkTree(field, rules, i, options){
	var total = 0;
	$('input[type="text"]').each(function(){
		if( $(this).val() === "")
			total = total + 1;
	});
	if (total > 1 || total === 0) {
		// rules.push('groupRequired');
		return options.allrules.required3fields.alertText;
	}
}

$(document).ready(function() {

	FastClick.attach(document.body);

	/**
	 * Test si les Media Queries sont supportées
	 * Ajoute la classe 'mq' au tag HTML si c'est le cas
	 */
	if ( Modernizr.mq('only all') ) {
		jQuery('html').addClass('mq');
	} else {
		jQuery('html').addClass('no-mq');
	}

	/**
	 * Browser detect : masquage de la bannière
	 */
	$('.browserdetect__close').click(function(e) {
		e.preventDefault();
		$('.browserdetect').addClass('browserdetect--hidden');
	});

	/**
	 * MatchHeight [GRID]
	 */
	$(".harmonize").matchHeight();

	$('[data-link]').click(function() {
		window.location.href = $(this).attr('data-link');
	}).find('a').click(function(e) {
		e.stopPropagation();
	});

	$(".page__menu .subnav-toggle").click(function(e){
		e.preventDefault();
		$(this).next('ul').slideToggle(function(){
			nav.resize();
		});
		$(this).parent('li').toggleClass('subnav-toggle--open');
	});
		
	$(".touch .subnav-toggle").click(function(e){
		e.preventDefault();
		$('li.subnav-toggle--open').children('ul').slideUp();
		$(this).next('ul').slideToggle(function(){
			nav.resize();
		});
		$(this).parent('li').toggleClass('subnav-toggle--open');
	});

	if( $(".nav-page").length > 0 ){
		var navPage = responsiveNav(".nav-page", { // Selector
			label: "", // String: Label for the navigation toggle
			customToggle: ".custom-toggle-page"
		});
	}

	if( $("#map").length > 0 ){
		var lat  = $("#map").attr('data-lat');
		var lng  = $("#map").attr('data-lng');
		var coordinates = {
			lat: parseFloat(lat),
			lng: parseFloat(lng)
		};
		var zoom = ( parseInt($("#map").attr('data-zoom')) || 10 );
		map = new GMaps({
			div: '#map',
			lat: lat,
			lng: lng,
			zoom: zoom,
			scrollwheel:      false,
			resize: function() {
    			this.setCenter(coordinates);
  			},
			styles : [{"featureType":"administrative","elementType":"all","stylers":[{"visibility":"on"},{"lightness":33}]},{"featureType":"administrative","elementType":"labels","stylers":[{"saturation":"-100"}]},{"featureType":"administrative","elementType":"labels.text","stylers":[{"gamma":"0.75"}]},{"featureType":"administrative.neighborhood","elementType":"labels.text.fill","stylers":[{"lightness":"-37"}]},{"featureType":"landscape","elementType":"geometry","stylers":[{"color":"#f9f9f9"}]},{"featureType":"landscape.man_made","elementType":"geometry","stylers":[{"saturation":"-100"},{"lightness":"40"},{"visibility":"off"}]},{"featureType":"landscape.natural","elementType":"labels.text.fill","stylers":[{"saturation":"-100"},{"lightness":"-37"}]},{"featureType":"landscape.natural","elementType":"labels.text.stroke","stylers":[{"saturation":"-100"},{"lightness":"100"},{"weight":"2"}]},{"featureType":"landscape.natural","elementType":"labels.icon","stylers":[{"saturation":"-100"}]},{"featureType":"poi","elementType":"geometry","stylers":[{"saturation":"-100"},{"lightness":"80"}]},{"featureType":"poi","elementType":"labels","stylers":[{"saturation":"-100"},{"lightness":"0"}]},{"featureType":"poi.attraction","elementType":"geometry","stylers":[{"lightness":"-4"},{"saturation":"-100"}]},{"featureType":"poi.park","elementType":"geometry","stylers":[{"color":"#c5dac6"},{"visibility":"on"},{"saturation":"-95"},{"lightness":"62"}]},{"featureType":"poi.park","elementType":"labels","stylers":[{"visibility":"on"},{"lightness":20}]},{"featureType":"road","elementType":"all","stylers":[{"lightness":20}]},{"featureType":"road","elementType":"labels","stylers":[{"saturation":"-100"},{"gamma":"1.00"}]},{"featureType":"road","elementType":"labels.text","stylers":[{"gamma":"0.50"}]},{"featureType":"road","elementType":"labels.icon","stylers":[{"saturation":"65"},{"gamma":"0.78"},{"visibility":"on"},{"weight":"0.90"},{"hue":"#00eaff"},{"lightness":"-20"}]},{"featureType":"road.highway","elementType":"geometry","stylers":[{"color":"#c5c6c6"},{"saturation":"-100"}]},{"featureType":"road.highway","elementType":"geometry.stroke","stylers":[{"lightness":"-13"}]},{"featureType":"road.highway","elementType":"labels.icon","stylers":[{"lightness":"0"},{"gamma":"1.09"}]},{"featureType":"road.arterial","elementType":"geometry","stylers":[{"color":"#e4d7c6"},{"saturation":"-100"},{"lightness":"47"}]},{"featureType":"road.arterial","elementType":"geometry.stroke","stylers":[{"lightness":"-12"}]},{"featureType":"road.arterial","elementType":"labels.icon","stylers":[{"saturation":"-100"}]},{"featureType":"road.local","elementType":"geometry","stylers":[{"color":"#fbfaf7"},{"lightness":"77"}]},{"featureType":"road.local","elementType":"geometry.fill","stylers":[{"lightness":"-5"},{"saturation":"-100"}]},{"featureType":"road.local","elementType":"geometry.stroke","stylers":[{"saturation":"-100"},{"lightness":"-15"}]},{"featureType":"transit.station.airport","elementType":"geometry","stylers":[{"lightness":"47"},{"saturation":"-100"}]},{"featureType":"water","elementType":"all","stylers":[{"visibility":"on"},{"color":"#acbcc9"}]},{"featureType":"water","elementType":"geometry","stylers":[{"saturation":"53"}]},{"featureType":"water","elementType":"labels.text.fill","stylers":[{"lightness":"-42"},{"saturation":"17"}]},{"featureType":"water","elementType":"labels.text.stroke","stylers":[{"lightness":"61"}]}]
		});

		var image = new google.maps.MarkerImage('/images/pointer.png', null, null, null, new google.maps.Size(80,80));
		
		map.addMarker({
			lat:  lat,
			lng:  lng,
			icon: image,
			zIndex: 100
		});
	}

	$('.fotorama').fotorama({
		maxwidth: '100%',
		nav: 'thumbs',
		margin:0,
		thumbwidth:114,
		thumbheight:65
	});

	var $fotoramaDiv = $('.diaporama').fotorama({
		maxHeight: '530px',
		width:'100%',
		ratio: '1800/990',
		fit:'cover',
		nav:false,
		autoplay:5000,
		transition:'crossfade',
		transitionduration:1000
	});
    var fotorama = $fotoramaDiv.data('fotorama');

	var waypoint = new Waypoint({
		element: $('.waypoint'),
		handler: function(direction) {
			if( direction === "down" ){
				$(".header").addClass('stuck');
				// nav.close();
			}else{
				$(".header").removeClass('stuck');
			}
		}
	});

    if( $("body").hasClass('home') ){
    	$('.diaporama').on('fotorama:load fotorama:showend', function(){
    		$('.fotorama__img').removeClass('animated');
    		$('.fotorama__active .fotorama__img').addClass('animated');
    	}).fotorama();
    }

    if( !$("body").hasClass('home') ){
    	fotorama.setOptions({
			maxHeight: '310px'
		});
    }

	/**
	 * Form
	 */
	$("input[type!=checkbox], textarea, select").focus(function(){
		$(this).parent('li').addClass('full-input');
	}).focusout(function(){
		if( $(this).val() === '' ){
			$(this).parent('li').removeClass('full-input');
		}else{
			$(this).parent('li').removeClass('full-input');			
		}
	});

	$("li:not('.checkbox') label").click(function(){
		$(this).addClass('full').next('input, textarea').focus();
	});

	$("select").each(function(){
		if( $(this).find('option:selected').val() !== "" ){
			$(this).prev("label").addClass('full');
		}
	});

	$(".form").validationEngine({ 
		scroll: false,
		showPrompts: false,
		onFieldFailure: function(_input, _text){
			_input.closest('li').addClass('error');
			_input.closest('li').find('.error-input').addClass('active').html(_text.replace('<br/>',' ').replace('<br>',' '));
		},
		onFieldSuccess: function(_input){
			_input.closest('li').removeClass('error');
			_input.closest('li').find('.error-input').removeClass('active').html('');
		}
	});

	$("#fContact, #fEtude").submit(function(){
		if($(this).validationEngine('validate')){
			var data = $(this).serialize() + '&act=envoi';
			var div = $("button", this).addClass('loading');
			$.ajax({			
				url:'/fr/contact/',
				data: data,
				type : 'POST',
				success: function(retour) {
					div.html( div.data('send') ).addClass('valid');
					window.setTimeout(function(){
						div.removeClass('valid').removeClass('loading').html(div.data('default'));
					},2000);
				}
			});
			return false;
		}
		return false;
	});

	$("#fRappel").submit(function(){
		if($(this).validationEngine('validate')){
			var data = $(this).serialize() + '&act=rappel';
			var div = $("li.input").html('demande en cours');
			$.ajax({			
				url:'/fr/contact/',
				data: data,
				type : 'POST',
				success: function(retour) {
					div.html( retour );
				}
			});
			return false;
		}
		return false;
	});

	$("#Emprunt").submit(function(){
		if($(this).validationEngine('validate')){
			calcul();
			return false;
		}
		return false;
	});

	$("#fNewsletter").submit(function(){
		if($(this).validationEngine('validate')){
			var data = $(this).serialize() + '&act=newsletter';
			var div = $("button", this).addClass('loading');
			$.ajax({			
				url:'/fr/contact/',
				data: data,
				type : 'POST',
				success: function(retour) {

					try {

						retour = JSON.parse(retour);
						style = "valid";
						if( retour.error ){ style = "error"; }
						div.html( retour.msg ).addClass(style);
						window.setTimeout(function(){
							div.removeClass('valid loading error').html(div.data('default'));
						},2000);

					}catch(e){

						div.html(retour);

					}
				}
			});
			return false;
		}
		return false;
	});

	if( $("#progam__container").length > 0 ){
		getIsotope();
	}

	$(".programme__detail").fitVids();
	$(".program-thumb__video").fitVids();

	if( $("#map").length > 0 ){
		var resizingTimeOut;
		$(window).resize(function() {
			clearTimeout(resizingTimeOut);
			resizingTimeOut = setTimeout(function() {
				map.refresh();
			}, 200);
		});
	}

	$(window).resize(function() {
		$(".menu .subnav-toggle").next('ul').slideUp(0);
	});

});